import React, { useState } from "react";
import { Typography } from "@mui/material";
import {  useQueryClient } from "@tanstack/react-query";
import { useParams, useSearchParams } from "react-router-dom";

import searchIcone from "../../../../../../../styles/svg/search-icon.svg";
import { addSubtask } from "../../../../../../../sevices/apiCards";
import DropdownWithSearchbar from "../../../../../../../components/DropdownWithSearchbar";
import { useCards } from "../../../../../../../utils/reactQuery/cards";
import FormDialog from "../../../../../../../components/Dialog/FormDialog";
import { CustomButton } from "../../../../../../../components/Button/Button";
import useMutate from "../../../../../../../hooks/useMutate";
import useBoardIdByKey from "../../../../../../../hooks/useBoardIdByKey";

const AssignSubtask = ({ ref, cardDetail }) => {
  const [childId, setChildId] = useState([]);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [conformationPopup, setConformationPopup] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const open = Boolean(anchorEl);
  const queryClient = useQueryClient();
  const [searchParams] = useSearchParams();
  const board_id = searchParams.get("brd_id");
  const card_id = cardDetail.card_id || Number(searchParams.get("card_id"));
  const { id } = useBoardIdByKey();
  const { cards } = useCards(cardDetail.board_id);
  const cardsOnBoard = cards?.data?.data?.responseData;

  const filteredCards = cardsOnBoard?.filter((item) => {
    return (
      item?.card?.card_id !== card_id &&
      item?.card?.card_id !== cardDetail?.parent_card_id &&
      !item?.card?.parent_card_id &&
      !item?.sub_tasks?.some(
        (subtaskItem) => subtaskItem === item?.card?.card_id
      ) &&
      (item?.key + "-" + item?.card?.card_id)
        .toLowerCase()
        .includes(searchQuery.toLowerCase())
    );
  });

  const { mutate: updateCardmutate, isPending } = useMutate(addSubtask,['subTasks','mineCards'],
    ()=>{},
    () => {
      queryClient.invalidateQueries({
        queryKey: [`cards`, id ?? board_id],
      });
      queryClient.invalidateQueries({
        queryKey: [`cards`, String(id ?? board_id)],
      });
      queryClient.invalidateQueries({
        queryKey: [`card`, Number(card_id)],
      });
      queryClient.invalidateQueries({
        queryKey: [`subTasks`, Number(card_id)],
      });
      queryClient.invalidateQueries({
        queryKey: [`mineCards`],
      });queryClient.invalidateQueries({
        queryKey: [`userCards`],
      });queryClient.invalidateQueries({
        queryKey: [`assignedCards`],
      });
      queryClient.invalidateQueries({
        queryKey: [`watching`],
      });
      
      //toast.success(res.data.message);
      setConformationPopup(false);
    },
    () => {
      //toast.error(error.response.data.message);
      setConformationPopup(false);
    },
  );

  const handleConfirmationPopup = (cardId) => {
    setChildId(cardId);
    setConformationPopup(true);
  };
  const handleDependsClose = (event) => {
    updateCardmutate({
      parentId: Number(card_id),
      childId: childId,
    });
  };

  return (
    <>
      {conformationPopup && (
        <FormDialog
          open={conformationPopup}
          handleClose={() => setConformationPopup(false)}
          loading={isPending}
          handleSubmit={handleDependsClose}
          buttonTxt="Assign"
          title="Confirmation: Assign subtask"
          alignActions={"center"}
          cancelBtn={true}
          fullWidth={true}>
          <Typography className="align_text_center mb-2">
            Are you sure you want to subtask.
          </Typography>
        </FormDialog>
      )}
      <CustomButton
        className="assign-subtask-box reset-btn"
        onClick={(event) => setAnchorEl(event.currentTarget)}>
        <img
          src={searchIcone}
          width={14}
          alt=""
          style={{ cursor: "pointer" }}
        />
        <Typography className="assign-subtask">Assign subtask</Typography>
      </CustomButton>
      <DropdownWithSearchbar
        anchorEl={anchorEl}
        open={open}
        setAnchorEl={setAnchorEl}
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        filteredCards={filteredCards}
        handleConfirmationPopup={handleConfirmationPopup}
        renderItemLabel={(item) => `${item.key}-${item.card.card_id}`}
        ref={ref}
        showNone={false}
      />
    </>
  );
};

export default AssignSubtask;
